import { getDoc, doc } from 'firebase/firestore';
import { firestore } from '../firebaseConfig';

// srsIntervals moved to utils/srs.js, alongside the scheduling rules that use it.

// Function to fetch word data based on word IDs
export const getWordsData = async (wordIds) => {
  // Create an array of promises to fetch each word document in parallel
  const wordPromises = wordIds.map(async (wordId) => {
    const docSnapshot = await getDoc(wordId.word_id);

    if (docSnapshot.exists()) {
      return { id: docSnapshot.id, ...wordId, ...docSnapshot.data() }; // Return word data if exists
    } else {
      return { id: wordId.word_id, missing: true }; // Mark word as missing if not found
    }
  });

  // Resolve all promises in parallel
  const wordsData = await Promise.all(wordPromises);

  return wordsData;
};

// Returns the raw counts doc for the given type:
// - 'sentences' → the full per-(JLPT, WK) histogram from counts/sentences_by_wk:
//   { "1": { "0": n, ..., "61": n }, ..., "5": { ... } }
// - 'words' → flat per-level counts from counts/words: { "0": n, ..., "5": n }
export const getTotalCounts = async (type) => {
  const docPath = type === 'sentences' ? 'sentences_by_wk' : type;
  const snap = await getDoc(doc(firestore, 'counts', docPath));
  if (!snap.exists()) {
    throw new Error(`counts/${docPath} not found`);
  }
  return snap.data();
};
